import {
  ADD_ERROR,
  CLEAR_ERRORS,
  REMOVE_ERROR,
  REMOVE_ERROR_BY_ROW_ID,
} from '../actions/ErrorActions';

function errors(state = [], action) {
  switch (action.type) {
    case ADD_ERROR:
      // eslint-disable-next-line no-case-declarations
      const err = {
        ...action,
        code: action.code,
        message: action.message,
        isTopBanner: action.isTopBanner,
        hasFetchError: action.hasFetchError,
        source: action.source,
      };

      if (action.noFilter) {
        return [...state, err];
      }

      return [...state.filter((error) => error.message !== err.message), err];
    case REMOVE_ERROR:
      return state.filter((error) => error !== action.error);
    case CLEAR_ERRORS:
      return typeof action.filter === 'function' ? state.filter(action.filter) : [];
    case REMOVE_ERROR_BY_ROW_ID:
      return [...state.filter((error) => error.rowID !== action.rowID)];
    default:
      return state;
  }
}

export default errors;
